'use strict'

import Swiper from 'swiper'

let self

export default self = {
  servicesLanding: null,
  homeCaseStudy: null,
  greyCta: null,
  whatNew: null,
  detailListingTop: null,
  detailListingTopSwiper: null,
  detailListingThumbs: null,
  detailListingThumbsSwiper: null,
  caseStudies: null,
  testimonials: null,
  caseStudyDetail: null,

  init : () => {
    self.servicesLanding = document.querySelector('#buyingSellingLanding .swiper-container');
    self.homeCaseStudy = document.querySelector('#home-case-studies .swiper-container');
    self.greyCta = document.querySelector('#home-grey-cta .swiper-container');
    self.whatNew = document.querySelector('.whats-new .swiper-container');
    self.detailListingTop = document.querySelector('#listing-detail .gallery-top');
    self.detailListingThumbs = document.querySelector('#listing-detail .gallery-thumbs');
    self.caseStudies = document.querySelector('#case-studies .swiper-container');
    self.testimonials = document.querySelector('#testimonials .swiper-container');
    self.caseStudyDetail = document.querySelectorAll('#case-study-detail .picture-container');

    if(self.servicesLanding) self.servicesLandingSlide();
    if(self.homeCaseStudy) self.homeCaseStudySlide();
    if(self.greyCta) self.greyCtaSlide();
    if(self.whatNew) self.whatNewSlide();
    if(self.detailListingTop && self.detailListingThumbs){
      self.detailListingTopSlide();
      self.detailListingThumbsSlide();
      self.detailListingTopSwiper.params.control = self.detailListingThumbsSwiper;
      self.detailListingThumbsSwiper.params.control = self.detailListingTopSwiper;
    }
    if(self.caseStudies) self.caseStudiesSlide();
    if(self.testimonials) self.testimonialsSlide();
    if(document.querySelector('body').classList.contains('single-case_studies')) self.caseStudyDetailSlide();

  },

  servicesLandingSlide: () => {
    const serviceSwiper = new Swiper (self.servicesLanding, {
      pagination: '.swiper-pagination',
      direction: 'horizontal',
      slidesPerView: 1,
      paginationClickable: true,
      mousewheelControl: true,
      parallax: true,
      speed: 600,
    });
  },

  homeCaseStudySlide : () => {
    const mySwiper = new Swiper (self.homeCaseStudy, {
        speed: 1000,
        effect: 'coverflow',
        coverflow: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows : false
        },
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 5000,
        loop: true
      })
  },

  greyCtaSlide : () => {
    const mySwiper = new Swiper (self.greyCta, {
        speed: 800,
        loop: true,
        effect: 'fade',
        fade: {
          crossFade: true
        },
        autoplay: 5000
      })
  },

  whatNewSlide : () => {
    const mySwiper = new Swiper (self.whatNew, {
        effect: 'slide',
        slidesPerView: 3,
        direction: 'vertical',
        autoplay: 5000,
        loop: true,
        speed: 800
      })
  },

  detailListingTopSlide : () => {
    self.detailListingTopSwiper = new Swiper (self.detailListingTop, {
      nextButton: '.btn.next',
      prevButton: '.btn.prev',
      spaceBetween: 10,
      loop: true,
      loopedSlides: 14,
      speed: 800
    })
  },

  detailListingThumbsSlide : () => {
    self.detailListingThumbsSwiper = new Swiper (self.detailListingThumbs, {
      spaceBetween: 10,
      centeredSlides: true,
      slidesPerView: 'auto',
      touchRatio: 0.2,
      slideToClickedSlide: true,
      loop: true,
      loopedSlides: 14,
      autoplay: 5000,
      speed: 800
      })
  },

  caseStudiesSlide : () => {
      let slideWidth = document.querySelector('#case-studies .swiper-slide').clientWidth;
      let margin = (slideWidth * 2) * 0.04;

      const mySwiper = new Swiper (self.caseStudies, {
          nextButton: '#case-studies .btn-next',
          prevButton: '#case-studies .btn-prev',
          speed: 800,
          effect: 'slide',
          spaceBetween: margin,
          width: slideWidth
        })

      // Resizing
      window.addEventListener("resize", () => {
          slideWidth = document.querySelector('#case-studies .swiper-slide').clientWidth;
          margin = (slideWidth * 2) * 0.04;
          mySwiper.params.width = slideWidth;
          mySwiper.params.spaceBetween = margin;
        }
      );
  },

  testimonialsSlide : () => {
      let slideWidth = document.querySelector('#testimonials .swiper-slide').clientWidth;
      let margin = (slideWidth * 2) * 0.1;

      const mySwiper = new Swiper (self.testimonials, {
          nextButton: '#testimonials .btn-next',
          prevButton: '#testimonials .btn-prev',
          speed: 800,
          effect: 'slide',
          spaceBetween: margin,
          width: slideWidth
        })

      // Resizing
      window.addEventListener("resize", () => {
          slideWidth = document.querySelector('#testimonials .swiper-slide').clientWidth;
          margin = (slideWidth * 2) * 0.1;
          mySwiper.params.width = slideWidth;
          mySwiper.params.spaceBetween = margin;
        }
      );
  },

  caseStudyDetailSlide : () => {
    let slideWidth = document.querySelector('#case-study-detail .swiper-slide').clientWidth;
    let margin = (slideWidth * 2) * 0.04;

    // Add class name for each gallery container
    [...self.caseStudyDetail].forEach((slider, index)=>{
      return slider.classList.add(`slider-${index + 1}`);
    });

    // Create Each Swiper Object
    const sliderArray = [];
    const caseStudySwiper = document.querySelectorAll('#case-study-detail .swiper-container');

    [...caseStudySwiper].forEach((slider, index)=>{
        sliderArray[index] = new Swiper (slider, {
          nextButton: document.querySelector(`.slider-${index + 1} .picture-nav-next`),
          prevButton: document.querySelector(`.slider-${index + 1} .picture-nav-prev`),
          pagination: document.querySelector(`.slider-${index + 1} .picture-pagination`),
          paginationType: 'fraction',
          speed: 800,
          width: slideWidth,
          spaceBetween: margin,
          effect: 'slide'
        });
    });

    // Init
    sliderArray.forEach(slider => slider.init());

    // Resizing
    window.addEventListener("resize", () => {
      slideWidth = document.querySelector('#case-study-detail .swiper-slide').clientWidth;
      margin = (slideWidth * 2) * 0.04;

      sliderArray.forEach(slider => {
        slider.params.width = slideWidth;
        slider.params.spaceBetween = margin;
      });
      }
    );

  },


}
